
const title = "Clinica Dental - Dra. Liliana Martinez S."
export const bg_azul_consulta = "#01479E"
export const bg_verde_consulta = "#87AF20"

export default title
